module.exports = __webpack_public_path__ + "img/Utilize2.409b7618.png";